import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { createTask } from "../../services/createTask";
import { term } from "../../terms";

function CreateTaskForm() {
    const navigate = useNavigate();
    const params = useParams();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [form, setForm] = useState({
        id: params.id,
        name: "",
    });

    async function create() {
        if (form.name) {
            const task = await createTask(form);
            console.log(task);
            alert(task.data.message);
            if (task.data.success) {
                navigate(`/services/${params.id}`);
            }
        } else {
            alert("Name can't be empty!");
        }
    }

    return (
        <section>
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    {/*  Site header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <main>
                        <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                            <div className="flex flex-col items-start max-w-2xl">
                                <Breadcrumbs
                                    home="/services"
                                    pages={[
                                        {
                                            name: "Service",
                                            href: `/services/${params.id}`,
                                            current: true,
                                        },
                                        {
                                            name: "Create task",
                                            href: `/services/${params.id}/task/create`,
                                            current: true,
                                        },
                                    ]}
                                />

                                {/* Page header */}
                                <div className="w-full mt-12 mb-8 sm:flex sm:justify-between sm:items-center">
                                    {/* Left: Title */}
                                    <div className="mb-4 sm:mb-0">
                                        <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                            Create {term("step_singular")}
                                        </h1>
                                    </div>
                                </div>

                                <div className="relative w-full bg-white border rounded-sm shadow-lg border-slate-200">
                                    <header className="px-5 py-4 border-b border-slate-200">
                                        <h2 className="font-semibold text-slate-800">
                                            Details
                                        </h2>
                                    </header>

                                    <div className="px-5 py-4 space-y-5">
                                        <div>
                                            <label
                                                htmlFor="email"
                                                className="block text-sm font-medium text-gray-700"
                                            >
                                                Name
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    onChange={(e) =>
                                                        setForm({
                                                            ...form,
                                                            name: e.target.value,
                                                        })
                                                    }
                                                    type="text"
                                                    value={form.name}
                                                    className="w-full max-w-sm p-1 px-2 border rounded-sm shadow-sm border-slate-200 focus:ring-0 focus:outline-none"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end w-full">
                                    <button
                                        onClick={() => create()}
                                        type="submit"
                                        className="z-50 inline-flex justify-center px-4 py-2 mt-4 ml-3 text-sm font-medium text-white bg-teal-500 border border-transparent rounded-sm shadow-sm hover:bg-teal-600 focus:outline-none focus:ring-0"
                                    >
                                        Create
                                    </button>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </section>
    );
}
export default CreateTaskForm;
